var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssistant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5202 10.9745C14.4426 10.8128 14.5989 10.6412 14.7659 10.6826L16.5897 11.106C16.6603 11.1259 16.7399 11.1058 16.792 11.0487L18.1792 9.76621C18.3158 9.63884 18.5252 9.72338 18.534 9.90077L18.6431 11.7265C18.6466 11.7975 18.6867 11.8658 18.7507 11.9003L20.3981 12.7567C20.556 12.8379 20.5343 13.0638 20.3726 13.1289L18.6161 13.8363C18.5514 13.8623 18.4993 13.9195 18.4813 13.9992L18.1098 15.8134C18.0779 15.9831 17.854 16.0491 17.7375 15.9151L16.5399 14.5277C16.4933 14.4741 16.4185 14.4439 16.3497 14.4596L14.4864 14.7155C14.308 14.739 14.1813 14.5488 14.2838 14.399L15.305 12.8297C15.3421 12.7665 15.3494 12.6912 15.3243 12.6289L14.5202 10.9745Z",
    fill: "#FFC71B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8809 14.1007C16.7326 13.9192 16.4975 13.833 16.2611 13.8679L14.9544 14.0443L15.6658 12.9496C15.7988 12.7513 15.8122 12.5046 15.7137 12.291L15.1659 11.1486L16.4374 11.4447C16.5786 11.4843 16.7354 11.4694 16.8755 11.413C16.9617 11.3782 17.033 11.3375 17.0959 11.276L18.0626 10.38L18.1369 11.6528C18.1558 11.8864 18.2867 12.087 18.4937 12.1967L19.6375 12.7975L18.4089 13.2923C18.1826 13.3835 18.0197 13.5697 17.9764 13.8043L17.7203 15.0654L16.8809 14.1007Z",
    fill: "url(#paint0_linear_943_26841)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6278 16.4718C13.5944 16.3888 13.6597 16.3022 13.756 16.3237L14.7643 16.557C14.805 16.5647 14.8373 16.5517 14.8654 16.5283L15.6327 15.8212C15.6956 15.7597 15.8111 15.7976 15.808 15.8833L15.8658 16.8974C15.8675 16.9329 15.8909 16.9597 15.9249 16.9821L16.8426 17.4569C16.9216 17.4975 16.9161 17.6083 16.8299 17.643L15.8492 18.038C15.8169 18.051 15.7929 18.0848 15.7797 18.1142L15.5694 19.1157C15.5555 19.2057 15.4394 19.2283 15.3778 19.1687L14.7166 18.3976C14.6932 18.3708 14.6633 18.3588 14.6268 18.3614L13.5823 18.5046C13.4878 18.5186 13.4352 18.4191 13.4831 18.3516L14.0483 17.4846C14.0722 17.4509 14.0705 17.4154 14.0579 17.3843L13.6278 16.4718Z",
    fill: "#FFC71B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1379 18.385C14.943 18.1499 14.6373 18.0438 14.3278 18.084L13.9603 18.1355L14.1611 17.8255C14.3313 17.5639 14.3561 17.2523 14.2217 16.9808L14.0664 16.6573L14.426 16.7417C14.6079 16.7891 14.8012 16.7715 14.9844 16.6977C15.0922 16.6543 15.1808 16.5945 15.276 16.52L15.5492 16.2652L15.5668 16.62C15.5893 16.9246 15.756 17.1831 16.027 17.3273L16.347 17.5L16.0022 17.6388C15.7112 17.756 15.5069 17.9951 15.4414 18.2989L15.3711 18.653L15.1379 18.385Z",
    fill: "url(#paint1_linear_943_26841)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1457 21.828C21.068 21.6663 21.2244 21.4947 21.3913 21.5361L22.1255 21.7108C22.1961 21.7306 22.2757 21.7106 22.3278 21.6534L22.8849 21.1396C23.0214 21.0122 23.2308 21.0968 23.2397 21.2742L23.2875 22.0148C23.291 22.0858 23.331 22.1541 23.3951 22.1886L24.0609 22.5357C24.2188 22.6168 24.197 22.8427 24.0354 22.9078L23.3241 23.1943C23.2595 23.2203 23.2074 23.2775 23.1893 23.3571L23.0462 24.0903C23.0144 24.2599 22.7905 24.326 22.6739 24.192L22.195 23.6249C22.1484 23.5713 22.0736 23.5411 22.0048 23.5568L21.244 23.6581C21.0656 23.6817 20.9389 23.4915 21.0414 23.3416L21.4495 22.7068C21.4867 22.6436 21.4939 22.5683 21.4689 22.506L21.1457 21.828Z",
    fill: "#FFC71B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6038 23.5207C22.394 23.2795 22.0841 23.1631 21.7531 23.2119L21.5059 23.2512L21.6455 23.0381C21.8223 22.7619 21.8495 22.4252 21.7109 22.1433L21.6082 21.9193L21.8565 21.9761C22.0492 22.0191 22.2575 22.0076 22.4407 21.9338C22.5484 21.8904 22.6586 21.8219 22.7389 21.7413L22.921 21.5715L22.9333 21.8198C22.9492 22.1391 23.1351 22.4141 23.421 22.5643L23.643 22.68L23.4059 22.7755C23.1041 22.897 22.8825 23.1551 22.8211 23.4693L22.7671 23.7083L22.6038 23.5207Z",
    fill: "url(#paint2_linear_943_26841)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3219 15.4607C26.3281 15.2893 26.5287 15.1965 26.6692 15.2967L28.3941 16.532C28.4474 16.5709 28.5138 16.5803 28.5826 16.5647L30.6731 15.9399C30.8389 15.8852 30.9896 16.0416 30.932 16.2095L30.215 18.2233C30.1886 18.2821 30.2029 18.3488 30.2388 18.4067L31.4456 20.1281C31.5406 20.2708 31.4399 20.4561 31.2639 20.4546L29.0879 20.4625C29.0256 20.4634 28.9502 20.4938 28.9088 20.5466L27.5643 22.2461C27.4577 22.3856 27.2435 22.3513 27.1915 22.1912L26.5715 20.1852C26.5464 20.123 26.4998 20.0694 26.4441 20.0556L24.4063 19.3806C24.246 19.3245 24.2138 19.1203 24.3588 19.0137L26.1469 17.7628C26.2074 17.7263 26.2338 17.6675 26.2411 17.5922L26.3219 15.4607Z",
    fill: "#FFC71B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9547 19.8018C26.8969 19.5959 26.7312 19.4334 26.5302 19.3696L24.9842 18.8584L26.3442 17.9126C26.5214 17.793 26.6395 17.5886 26.6505 17.3671L26.7171 15.76L28.0246 16.7051C28.1992 16.8277 28.4284 16.8681 28.6415 16.8064L30.2261 16.325L29.6754 17.8496C29.6046 18.047 29.6343 18.2763 29.7568 18.4561L30.6719 19.7643L29.0195 19.7663C28.9316 19.7656 28.837 19.7795 28.7508 19.8143C28.6322 19.862 28.5262 19.9409 28.4501 20.0318L27.4298 21.3234L26.9547 19.8018Z",
    fill: "url(#paint3_linear_943_26841)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6826 10.414C27.6199 10.2583 27.7654 10.0911 27.9431 10.1281L29.3409 10.4578C29.4115 10.4776 29.4803 10.4619 29.5366 10.4151L30.6602 9.50424C30.7902 9.39158 30.9996 9.47612 31.0042 9.64313L31.0814 11.0475C31.0849 11.1185 31.1207 11.1764 31.1848 11.2109L32.3978 11.9528C32.545 12.0383 32.519 12.2538 32.3574 12.3189L31.0061 12.851C30.9415 12.877 30.8894 12.9342 30.8779 12.9991L30.5027 14.3686C30.4558 14.5322 30.2386 14.5835 30.1261 14.4599L29.2192 13.3898C29.1726 13.3362 29.1127 13.312 29.0397 13.3173L27.5943 13.429C27.4225 13.4379 27.3108 13.2537 27.4025 13.1082L28.1965 11.9078C28.2379 11.855 28.2451 11.7797 28.22 11.7174L27.6826 10.414Z",
    fill: "#FFC71B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4978 12.867C29.3579 12.7063 29.1443 12.6113 28.9145 12.6315L28.0018 12.6976L28.4992 11.9424C28.6256 11.7587 28.6432 11.5225 28.5638 11.3253L28.2335 10.5053L29.1197 10.7154C29.2717 10.7507 29.4177 10.7401 29.5578 10.6837C29.6225 10.6576 29.6937 10.6169 29.7392 10.5744L30.4472 9.99979L30.4912 10.8867C30.5018 11.0996 30.6219 11.3045 30.8074 11.4229L31.5706 11.8875L30.7193 12.2303C30.5037 12.3171 30.3474 12.4887 30.2957 12.7025L30.0568 13.5707L29.4978 12.867Z",
    fill: "url(#paint4_linear_943_26841)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0156 20.7028L12.9506 31.5216C12.7498 31.8317 12.3416 31.8755 12.0862 31.6768C12.0139 31.6215 11.9439 31.5411 11.9063 31.4477C11.8436 31.292 11.8497 31.1206 11.9414 30.9751L18.2118 19.4269L18.641 18.6268L20.0156 20.7028Z",
    fill: "url(#paint5_linear_943_26841)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3023 11.0905L20.0271 20.6986L18.674 18.6139L23.7161 9.3336C24.8235 7.72958 24.9197 8.55934 25.4315 9.05282L26.179 9.78917C26.5228 10.1453 26.575 10.6791 26.3023 11.0905Z",
    fill: "url(#paint6_linear_943_26841)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0164 20.7029L12.9513 31.5218C12.7505 31.8318 12.3423 31.8756 12.087 31.6769L18.9204 20.8427L18.2125 19.427L18.6417 18.6269L20.0164 20.7029Z",
    fill: "#824EFC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_943_26841",
    x1: 16.6231,
    y1: 21.4111,
    x2: 16.9342,
    y2: 15.4739,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4302,
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6573,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8616,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_943_26841",
    x1: 14.7844,
    y1: 22.2761,
    x2: 15.0755,
    y2: 16.7199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4302,
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6573,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8616,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_943_26841",
    x1: 22.4679,
    y1: 24.0811,
    x2: 22.7491,
    y2: 18.7133,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0167598,
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1838,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.334,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4358,
    stopColor: "#FEEA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_943_26841",
    x1: 27.4775,
    y1: 23.4889,
    x2: 27.8059,
    y2: 17.2199,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3986,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7571,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_943_26841",
    x1: 29.0879,
    y1: 20.9584,
    x2: 29.3798,
    y2: 15.3878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.4302,
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6573,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8616,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEA3D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_943_26841",
    x1: 12.1792,
    y1: 30.2861,
    x2: 18.3556,
    y2: 20.7252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#824DFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5616,
    stopColor: "#935CFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A63FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_943_26841",
    x1: 17.7657,
    y1: 16.3943,
    x2: 27.3585,
    y2: 12.5308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3B117"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3986,
    stopColor: "#F1CF2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7571,
    stopColor: "#FBE338"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEEA3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistant);
export default __webpack_public_path__ + "static/media/assistant.a7b357834e4820a64f3a2feea27dbac3.svg";
export { ForwardRef as ReactComponent };